import { Tag } from "antd";
import styled from "styled-components";

export const StyledProductTagSpecial = styled(Tag)<{ $isDropout: boolean }>`
    border-radius: 12px;
    font-family: Inter;
    font-weight: 400;
    font-size: 12px;
    color: ${({ $isDropout }) => ($isDropout ? "#cea1fe" : "#8fc1fe")};
    background-color: ${({ $isDropout }) =>
        $isDropout ? "#301C4D" : "#0c2446"};
    line-height: 1.5;
`;
